import React from 'react'

const editplans = () => {
  return (
    <div>
      edit plans
    </div>
  )
}

export default editplans

